const LANGUAGES: Record<LanguagesTypes, LanguagesTypes> = {
  pt: 'pt',
  es: 'es',
  en: 'en',
}

export default LANGUAGES
